import { FeatureFlag } from './feature-flag';

export class CompanyFeatureFlag {
	public id: number;
	public companyId: string;
	public featureFlagId: number;
	public show: boolean;
	public value: boolean;

	public featureFlag: FeatureFlag;

	constructor(companyFeatureFlag?: CompanyFeatureFlag) {
		Object.assign(this, companyFeatureFlag);
		if (companyFeatureFlag?.featureFlag) {
			this.featureFlag = new FeatureFlag(companyFeatureFlag.featureFlag);
		}
	}
}
